<template>
  <v-ons-page @show="isPageShown = true" @hide="isPageShown = false">

    <!-- modifier noshadow KO -->
    <v-ons-toolbar class="toolbar--noshadow" modifier="perfhome">
      <div class="left">
        <v-ons-toolbar-button v-if="api && ! isSync" @click="callApi">
          <v-ons-icon icon="sync"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        <v-ons-toolbar-button @click="showActionSheet = true" modifier="perfrecolte" id="dropdown-recolte">
          Récolte {{ campagne }}
          <v-ons-icon icon="angle-down"></v-ons-icon>
          <div v-if="multiNotif" class="notification">{{ multiNotif }}</div>
        </v-ons-toolbar-button>
      </div>
      <div class="right">
        <v-ons-toolbar-button v-if="clientConnect.id" @click="clientLogout">
          <v-ons-icon icon="sign-out"></v-ons-icon>
        </v-ons-toolbar-button>
        <v-ons-toolbar-button v-else @click="showParams()">
          <img src="../assets/imgs/icon_cog@2x.png">
          <div v-if="paramsNotif" class="notification">{{ paramsNotif }}</div>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <app-pull-hook-spinner v-if="isSync"></app-pull-hook-spinner>

    <div class="content">

      <v-ons-tabbar :index.sync="tabbar.index" position="bottom" modifier="perfhome">
        <template v-if="! modal.isShow" slot="pages">
          <app-home-prix :page-stack="pageStack" @call-api="$emit('call-api', $event)" :init-infos="initTab.prix"
                         @show-home="showHome" @update-if-needed="updateIfNeeded" @show-params="showParams($event)"
                         @change-recolte="changeRecolte" @change-multi="$emit('change-multi', $event)"></app-home-prix>
          <app-home-ventes :page-stack="pageStack" @call-api="$emit('call-api', $event)" :init-infos="initTab.ventes"
                           @show-home="showHome"></app-home-ventes>
          <app-home-cultures :page-stack="pageStack" @call-api="$emit('call-api', $event)" :init-infos="initTab.cultures">
          </app-home-cultures>
        </template>

        <v-ons-tab label="Prix" icon="fa-perfchart" id="tab-prix"></v-ons-tab>
        <v-ons-tab label="Ventes" icon="fa-perfsales" :badge="ventesNotif ? ventesNotif : ''"></v-ons-tab>
        <v-ons-tab label="Cultures" icon="fa-perfleaf"></v-ons-tab>
      </v-ons-tabbar>

    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfalert'" :visible.sync="showOnboarding.step1">
      <template slot="title">
        <img src="../assets/imgs/badge_0feuille@2x.png"><br />
        Bienvenue {{ user.prenom }}&nbsp;!
      </template>
      Prenons 2 minutes pour configurer votre compte.
      <template slot="footer">
        <v-ons-button modifier="large--cta perflarge" @click="nextOnboarding">C'est parti</v-ons-button>
      </template>
    </v-ons-alert-dialog>

    <v-ons-popover modifier="perfarmer" :visible.sync="showOnboarding.step2" target="#dropdown-recolte" direction="down">
      <h2>Changez de récolte avec ce menu</h2>
      <p>Ou restez comme ça pour ajouter vos cultures {{ campagne }}.</p>
      <v-ons-button modifier="large--cta perflarge" @click="nextOnboarding">Allons-y pour {{ campagne }}</v-ons-button>
      <v-ons-toolbar-button @click="showActionSheet = true" modifier="perfrecolte">
        Récolte {{ campagne }}
        <v-ons-icon icon="angle-down"></v-ons-icon>
      </v-ons-toolbar-button>
    </v-ons-popover>

    <v-ons-popover modifier="perfarmer" :visible.sync="showOnboarding.step3" target="#tab-prix" direction="up" @preshow="preshowOnboardingStep3">
      <h2>Parfait, et les prix&nbsp;?</h2>
      <p>
        Consultez les {{ negoce.length ? 'prix de vos OS' : 'cours' }} et créez vos alertes sur cet onglet.
      </p>
      <v-ons-button modifier="large--cta perflarge" @click="nextOnboarding">Allons voir les prix</v-ons-button>
      <div @click="nextOnboarding" class="tabbar__button tabbar--perfhome__button">
        <div class="tabbar__icon"><ons-icon icon="fa-perfchart"></ons-icon></div>
        <div class="tabbar__label">Prix</div>
      </div>
    </v-ons-popover>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfalert'" :visible.sync="showOnboarding.step4" cancelable>
      <template slot="title">
        <img src="../assets/imgs/badge_3feuille@2x.png"><br />
        Découvrez vos prix OS
      </template>
      Indiquez les OS à qui vous vendez votre marchandise&nbsp;!
      <template slot="footer">
        <v-ons-button modifier="large--cta perflarge" @click="showNegoceRequest">Ajouter mes OS</v-ons-button>
      </template>
    </v-ons-alert-dialog>

    <v-ons-action-sheet :modifier="$mdModifier" :visible.sync="showActionSheet" cancelable title="Récolte">
      <v-ons-action-sheet-button :modifier="$mdModifier" v-for="(infosMulti, idMulti) in multiActionSheet" :key="idMulti"
                                 @click="changeRecolte({ idMulti: idMulti })" :style="{ 'font-weight': idMulti == user.id ? 'bold' : 'normal' }">
        {{ infosMulti.campagne }}
        <div v-if="infosMulti.notif" class="notification">{{ infosMulti.notif }}</div>
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="showActionSheet = false">Fermer</v-ons-action-sheet-button>
    </v-ons-action-sheet>

    <v-ons-modal :visible="modal.isShow">
      <p style="text-align: center">
        {{ modal.msg }}
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </p>
    </v-ons-modal>

    <app-badge :page-stack="pageStack" @show-home="showHome" @change-multi="$emit('change-multi', $event)"></app-badge>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

import AppBadge from '../partials/Badge.vue';
import AppPullHookSpinner from '../partials/PullHookSpinner.vue';

import AppHomePrix from './HomePrix.vue';
import AppHomeVentes from './HomeVentes.vue';
import AppHomeCultures from './HomeCultures.vue';
import AppNegoceRequest from './NegoceRequest.vue';
import AppParamsFerme from './ParamsFerme.vue';
import AppParams from './Params.vue';
import AppChat from './Chat.vue';

import { Crisp } from 'crisp-sdk-web';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppHomePrix, AppHomeVentes, AppHomeCultures, AppBadge, AppPullHookSpinner },
  props: ['pageStack'],
  data() {
    return {
      initPath: '',
      initTab: {},
      tabbar: {
        index: -1,
        prix: 0,
        ventes: 1,
        cultures: 2
      },
      isPageShown: false,
      showOnboarding: {
        step1: false,
        step2: false,
        step3: false,
        step4: false
      },
      showActionSheet: false,
      modal: {
        isShow: false,
        msg: ''
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    multi() {
      return this.state.multi;
    },
    multiActionSheet() {
      var list = {};
      var idUser = this.user.id.toString();
      idUser = idUser.substring(0, idUser.length - 4);
      for (const id in this.multi) {
        var idMulti = id.toString();
        idMulti = idMulti.substring(0, idMulti.length - 4);
        if(idMulti != idUser){
          continue;
        }
        var multiUser = this.multi[id];
        list[id] = {
          campagne: multiUser.campagne,
          notif: multiUser.nbNotif
        };
      }
      list[this.user.id] = {
        campagne: this.campagne,
        notif: 0
      };
      for (let i = this.cours.campagne - 1 - this.campagne; i <= this.cours.campagne + 2 - this.campagne; i++) {
        if (! list[parseInt(this.user.id) + i]) {
          list[parseInt(this.user.id) + i] = {
            campagne: this.campagne + i,
            notif: 0
          };
        }
      }
      return list;
    },
    multiNotif() {
      return Object.values(this.multiActionSheet).reduce((result, item) => { return result + item.notif; }, 0)
    },
    paramsNotif() {
      var count = 0;
      var idUser = this.user.id.toString();
      idUser = idUser.substring(0, idUser.length - 4);
      for (const id in this.multi) {
        var idMulti = id.toString();
        idMulti = idMulti.substring(0, idMulti.length - 4);
        if(idMulti == idUser){
          continue;
        }
        count += this.multi[id].nbNotif;
      }
      return count;
    },
    onboarding() {
      return this.state.onboarding.step;
    },
    api() {
      return this.state.api;
    },
    isSync() {
      return this.state.isSync;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cours() {
      return this.data.cours;
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    isMissingConfig() {
      return this.getMissingConfig(this.negoce);
    },
    isMissingRequest() {
      return ! this.negoce.length && this.user.request && ! this.user.request.length;
    },
    isMissingFerme() {
      return ! this.negoce.length && this.user.request && this.user.request.length && ! this.user.ferme.nom;
    },
    notifState() {
      return this.state.notif;
    },
    ventesNotif() {
      return this.getCampagneNotifCount(this.user.ventes, this.negoce, this.notifState);
    }
  },
  watch: {
    showActionSheet(value){
      if(value){
        this.showOnboarding.step2 = false;
      } else {
        this.setOnboarding();
      }
    },
    isPageShown(value) {
      if(value){
        this.setOnboarding();
      }
    },
    isMissingConfig(value) {
      if(value && this.isPageShown){
        this.tabbar.index = this.tabbar.cultures;
        this.setOnboarding();
      }
    },
    isMissingRequest(value) {
      if(value && this.isPageShown){
        this.setOnboarding();
      }
    }
  },
  methods: {
    updateIfNeeded() {
      if(! this.isSync){
        this.$emit('update-if-needed');
      } else {
        // debug console.log('update bypass isSync ' + this.isSync);
      }
    },
    callApi() {
      store.state.isSync = true;
      this.$emit('call-api', {
        done: function () { store.state.isSync = false; }
      });
    },
    showHome(event) {
      this.tabbar.index = this.tabbar[event.id];
      if(event.id == 'ventes' && event.refCulture && event.refDestination){
        this.initTab.ventes = {
          refCulture: event.refCulture,
          refDestination: event.refDestination
        };
      }
    },
    showParams(initInfos) {
      this.pageStack.push({
        extends: AppParams,
        data() {
          return {
            initInfos: initInfos
          }
        },
        onsNavigatorOptions: {
          animation: 'lift'
        }
      });
    },
    clientLogout() {
      store.state.client.id = '';
    },
    preshowOnboardingStep3(event){
      var tabWidth = this.$el.querySelector('#tab-prix').offsetWidth;
      event.target.querySelector('.tabbar--perfhome__button').style.width = tabWidth + 'px';
    },
    nextOnboarding() {
      this.sendTrackEvent('onboarding step ' + this.onboarding);

      this.showOnboarding.step1 = false;
      if (this.onboarding == 2 && !this.user.cultures.length) {
        this.initTab.cultures = -1; // ==>> HomeCultures watch initInfos
      }
      this.showOnboarding.step2 = false;
      if (this.onboarding >= 3) {
        this.tabbar.index = this.tabbar.prix;
      }
      this.showOnboarding.step3 = false;
      if (this.onboarding < 4) {
        store.state.onboarding.step += 1;
        this.ionicStorage.set('onboarding', this.state.onboarding);
      }
      this.setOnboarding();
    },
    setOnboarding() {
      if (this.onboarding == 1) {
        this.initTab.cultures = -2;
        this.showOnboarding.step1 = true;
      } else if (this.onboarding == 2) {
        this.initTab.cultures = -2;
        if(this.isMissingFerme){
          this.pageStack.push({
            extends: AppParamsFerme,
            data() {
              return {
                workflow: 'onboarding'
              }
            }
          });
        } else {
          this.showOnboarding.step2 = true;
        }
      } else {
        if(this.initTab.cultures == -2){
          this.initTab.cultures = 0;
        }
        if (this.user.cultures.length){
          if (this.onboarding == 3) {
            this.showOnboarding.step3 = true;
          } else if(this.isMissingConfig){
            if(this.tabbar.index != this.tabbar.prix){
              this.showOnboarding.step3 = true;
            }
          } else if(this.isMissingRequest || this.isMissingFerme){
            this.showOnboarding.step4 = true;
          } else if(! this.nbFeuille && this.negoce.length) {
            store.state.onboarding.nbFeuille += 1;
            this.ionicStorage.set('onboarding', this.state.onboarding);
            store.state.badge.type = 'feuille';
            this.sendTrackEvent('onboarding feuille ' + this.nbFeuille);

            this.$emit('set-push-ok');
          }
        }
      }
    },
    showNegoceRequest() {
      this.showOnboarding.step4 = false;
      this.pageStack.push(AppNegoceRequest);
    },
    async changeRecolte(event) {

      this.showActionSheet = false;

      if (event.idMulti == this.user.id) {
        // RAF
      } else if (this.multi[event.idMulti]) {

        let ongletCode = '/h';
        if (this.tabbar.index == this.tabbar.ventes) {
          ongletCode = '/v';
        } else if (this.tabbar.index == this.tabbar.cultures) {
          ongletCode = '/c';
        }
        event.initPath = event.idMulti.toString() + ongletCode;
        this.modal.msg = '';
        this.modal.isShow = true;
        this.$emit('change-multi', event); // switch récolte
        this.sendTrackEvent('recolte ' + this.multi[event.idMulti].campagne);

      } else if(this.multiActionSheet[event.idMulti]) {

        const newCampagne = this.multiActionSheet[event.idMulti].campagne;
        this.modal.msg = 'Création de votre campagne ' + newCampagne;
        this.modal.isShow = true;

        const fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify({
          campagne: newCampagne
        });
        const callPath = this.$apiDomain + this.getPath('/campagne');
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          const setStore = [ this.ionicStorage.set('user', response.user) ];

          const multi = await this.ionicStorage.get('multi');
          multi[this.user.id] = this.user;
          setStore.push(this.ionicStorage.set('multi', multi));

          await Promise.all(setStore);
          this.$emit('reload-app', {
            initPath: event.initPath
          });
        } catch(error) {
          this.modal.isShow = false;
          this.handleError(error, 'de la création de votre campagne ' + newCampagne, true);
        }
      }
    },
    setInitPath(initPath) {
      var path = initPath.split('/');
      var showTab = path.shift();
      if (showTab == 'h' || showTab == 'v') {
        this.tabbar.index = (showTab == 'h' ? this.tabbar.prix : this.tabbar.ventes);
        if (path.length > 1) {
          var codeCulture = path.shift();
          var codeDestination = path.shift();
          var initTab = {
            refCulture: (codeCulture != 'nd' && this.referentiel.codes.cultures[codeCulture] ?
              this.referentiel.codes.cultures[codeCulture] :
              codeCulture),
            refDestination: (codeCulture == 'ap' ?
              (this.referentiel.codes.appros[codeDestination] ?
                this.referentiel.codes.appros[codeDestination] :
                codeDestination) :
              (codeDestination != 'nd' && this.referentiel.codes.destinations[codeDestination] ?
                this.referentiel.codes.destinations[codeDestination] :
                codeDestination)),
            path: path.join('/')
          };
          if (showTab == 'h') {
            this.initTab.prix = initTab;
          } else {
            this.initTab.ventes = initTab;
          }
        }
      } else if (showTab == 'c') {
        this.tabbar.index = this.tabbar.cultures;
        if (path.length) {
          this.initTab.cultures = path.shift();
        }
      } else if (showTab == 'p') {
        this.tabbar.index = this.tabbar.prix;
        this.showParams(path.join('/'));
      } else {
        this.tabbar.index = this.tabbar.prix;
      }
    },
    setupCrisp() {
      var websiteId = this.data.negoce.crisp;
      if(! websiteId){
        websiteId = '1e927613-c843-43c1-81c7-418b6b4412a0';
      }
      Crisp.configure(websiteId, {
        autoload: false,
        safeMode: true,
      });
      if(this.$ons.platform.isIOS()){
        Crisp.message.onMessageReceived((data) => {
          if(! Crisp.chat.isChatOpened()){
            this.pageStack.push({
              extends: AppChat
            });
          }
        });
        Crisp.chat.onChatClosed(() => {
          Crisp.chat.hide();
          this.pageStack.pop();
        });
      } else {
        Crisp.chat.onChatClosed(() => {
          Crisp.chat.hide();
        });
        Crisp.message.onMessageReceived((data) => {
          Crisp.chat.show();
        });
      }
    }
  },
  created() {
    this.setupCrisp();
    if (this.initPath) {
      var path = this.initPath.split('/');
      var idMulti = path.shift();
      if (idMulti != this.user.id) {
        // from changeMulti create campagne
        this.changeRecolte({
          idMulti: idMulti,
          initPath: this.initPath
        });
      } else {
        this.setInitPath(path.join('/'));
        return;
      }
    } else if (!this.user.cultures.length || this.onboarding <= 3) {
      this.tabbar.index = this.tabbar.cultures;
      if (this.onboarding > 2) {
        this.initTab.cultures = -1;
      } else {
        this.initTab.cultures = -2;
      }
      return;
    } 
    this.tabbar.index = this.tabbar.prix;
  }
}
</script>

<style>
.tabbar--perfhome__button .tabbar__icon .fa-perfchart,
.popover--perfarmer__content .tabbar__icon .fa-perfchart {
  background-image: url("../assets/imgs/icon_chart@2x.png");
}
:checked + .tabbar--perfhome__button .tabbar__icon .fa-perfchart {
  background-image: url("../assets/imgs/icon_chart_active@2x.png");
}
.tabbar--perfhome__button .tabbar__icon .fa-perfsales {
  background-image: url("../assets/imgs/icon_sales@2x.png");
  margin-top: 1px;
}
:checked + .tabbar--perfhome__button .tabbar__icon .fa-perfsales {
  background-image: url("../assets/imgs/icon_sales_active@2x.png");
}
.tabbar--perfhome__button .tabbar__icon .fa-perfleaf {
  background-image: url("../assets/imgs/icon_leaf@2x.png");
}
:checked + .tabbar--perfhome__button .tabbar__icon .fa-perfleaf {
  background-image: url("../assets/imgs/icon_leaf_active@2x.png");
}

.pull-hook-container {
  position: absolute;
  width: 100%;
  text-align: center;
  margin-top: 44px;
}

.action-sheet-title--material {
  color: var(--perfarmer-gris-dark);
}

.popover--perfarmer .toolbar-button--perfrecolte {
  position: absolute;
  top: -36px;
  left: calc(50% - 68px);
  min-width: 114px;
  min-height: 19px;
}
/*
.popover--bottom__arrow {
  transform: translateY(12px) translateX(-18px) rotate(-45deg);
}

.popover__arrow {
  width: 36px;
  height: 36px;
}
*/

.popover--perfarmer__content .tabbar--perfhome__button {
  height: 55px;
  position: absolute;
  left: -6px;
  bottom: -69px;
  background-color: white;
}

.toast--tabbar {
  bottom: 55px;
}

.toolbar--perfhome__right .notification {
  margin-top: 1px;
  margin-left: -11px;
}

@media (orientation: portrait) {
  html[onsflag-iphonex-portrait] .toast--tabbar {
    bottom: 89px;
  }
}
@media (orientation: landscape) {
  html[onsflag-iphonex-landscape] .toast--tabbar {
    bottom: 76px;
  }
}
</style>
